module.exports = __webpack_public_path__ + "static/media/24.f82582cd.png";